module.exports = __webpack_public_path__ + "img/LP_Full_Blue.8ef4a22b.svg";